import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import Title from 'components/Title';
import { Switch } from 'components/buttons';
import { Plus } from 'components/icons';
import { FormContainer, FormItem, FormRow } from 'components/styledComponents';
import { useTranslation } from 'hooks';
import Form from './Form';
import { AddButton } from './style';

const EMPTY_MISSION = { monthsSpent: 0, assignmentType: '', country: '' };

function WorkAbroad({ className, useInput, onAdd, onDelete }) {
  const { t, tr } = useTranslation();
  const { value: rawWorkAbroad, onChange } = useInput('missionsAbroad');

  // Normalize workAbroad to always be an array
  const workAbroad = Array.isArray(rawWorkAbroad) ? rawWorkAbroad : [];

  const displayWorkAbroad = useMemo(() => workAbroad.length > 0, [workAbroad]);

  const handleAdd = useCallback(() => onAdd('missionsAbroad', EMPTY_MISSION), [onAdd]);

  const handleChange = useCallback(
    event => {
      const checked = event.target.checked;
      onChange(checked ? [EMPTY_MISSION] : []);
    },
    [onChange]
  );

  return (
    <FormContainer className={className}>
      <FormRow>
        <FormItem component={Title} label={tr('message.workAbroadQuestion')} size="default" />
        <FormItem
          component={Switch}
          leftLabel={tr('button.no')}
          rightLabel={tr('button.yes')}
          size="0"
          checked={displayWorkAbroad}
          onChange={handleChange}
        />
      </FormRow>

      <Collapse in={displayWorkAbroad} timeout="auto" unmountOnExit>
        {workAbroad.map((_, index) => (
          <Form
            key={index}
            basePath={`missionsAbroad[${index}]`}
            useInput={useInput}
            onDelete={() => onDelete(`missionsAbroad[${index}]`)}
          />
        ))}

        <AddButton
          color="default"
          contentFirst
          label={t('button.addNewExperienceAbroad')}
          variant="outlined"
          onClick={handleAdd}
        >
          <Plus fontSize="small" />
        </AddButton>
      </Collapse>
    </FormContainer>
  );
}

WorkAbroad.propTypes = {
  className: PropTypes.string,
  useInput: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default WorkAbroad;
